// extracted by mini-css-extract-plugin
export default {"mainContainer":"Events_mainContainer__BzCl7","comingSoonImg":"Events_comingSoonImg__ZSD19"};